import React from "react";
import likeIcon from "../assets/likeIcon.svg";
import shareIcon from "../assets/shareIcon.svg";
import phoneCallIcon from "../assets/phoneCallIcon.svg";
import mapPin from "../assets/mapPin.svg";
import globe from "../assets/globeIcon.svg";
import starIcon from "../assets/starIcon.svg";
import whatsappLogo from "../assets/whatsappLogo.svg";
import gmailLogo from "../assets/gmailLogo.svg";
import facebookLogo from "../assets/facebookLogo.svg";
import mailIcon from "../assets/mail.png";
import { useState } from "react";

function OverviewTitle({
  logo,
  name,
  rating,
  reviewCount,
  location,
  phone,
  website,
  description,
  mapImage,
  senderEmail,
}) {
  const encodedAddress = encodeURIComponent(location);
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${encodedAddress}`;

  const [showShareOptions, setShowShareOptions] = useState(false);

  const handleShareClick = () => {
    setShowShareOptions(!showShareOptions);
  };

  const handleShareOptionClick = (platform) => {
    let url = "";
    const shareMessage = `Check this out! ${website}`; // Customize your message

    switch (platform) {
      case "whatsapp":
        url = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
        break;

      case "mail":
      url = `mailto:?subject=Sharing&body=${encodeURIComponent(
        shareMessage
      )}`;
      break;

      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          window.location.href
        )}`;
        break;
      default:
        return;
    }

    window.open(url, "_blank");
    setShowShareOptions(false);
  };

  return (
    <div className="p-4 sm:p-6 md:p-0 mx-auto max-w-8xl">
      <div className="flex flex-col md:flex-row justify-between gap-6 mb-8">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <img
            src={`https://elsopro.com/vendor_images/images/${logo}`}
            alt={name}
            className="object-contain h-24 w-24 sm:h-32 sm:w-32 md:h-48 md:w-48"
          />
          <div className="flex flex-col gap-2 sm:gap-3">
            <h1 className="text-xl sm:text-2xl md:text-4xl font-bold">
              {name}
            </h1>
            <div className="flex items-center gap-2 text-sm sm:text-base">
              <img src={starIcon} className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>{rating}</span>
              <span className="text-gray-500">({reviewCount})</span>
            </div>
            <div className="flex flex-col sm:flex-row flex-wrap gap-1 sm:gap-3 text-gray-600 text-xs sm:text-sm">
              <div className="flex items-center gap-2 min-w-[150px]">
                <img src={mapPin} className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>{location}</span>
              </div>
              <div className="flex items-center gap-2 min-w-[150px]">
                <img src={phoneCallIcon} className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>{phone}</span>
              </div>
              <div className="flex items-center gap-2 break-words min-w-[150px]">
                <img src={mailIcon} className="w-4 h-4 sm:w-5 sm:h-5" />
                <span>{senderEmail}</span>
              </div>
              <div className="flex items-center gap-2 min-w-[150px]">
                <img src={globe} className="w-4 h-4 sm:w-5 sm:h-5" />
                <a href={website} target="_blank" rel="noopener noreferrer" className="text-gray-600 underline">
                  Website
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <div className="flex justify-center gap-4">
            <button onClick={handleShareClick} className="p-2 rounded-full">
              <img
                src={shareIcon}
                alt="share"
                className="w-4 sm:w-5 h-4 sm:h-5"
              />
            </button>
          </div>

          {showShareOptions && (
            <div className="absolute bg-white shadow-md rounded-md p-2 mt-2 flex gap-4">
              <button
                onClick={() => handleShareOptionClick("whatsapp")}
                className="p-2 rounded-full bg-green-500 text-white"
              >
                <img src={whatsappLogo} alt="Whatsapp" className="w-6 h-6" />
              </button>
              <button
                onClick={() => handleShareOptionClick("mail")}
                className="p-2 rounded-full bg-gray-200 text-white"
              >
                <img src={gmailLogo} alt="Mail" className="w-6 h-6" />
              </button>
              <button
                onClick={() => handleShareOptionClick("facebook")}
                className="p-2 rounded-full bg-blue-600 text-white"
              >
                <img src={facebookLogo} alt="Facebook" className="w-6 h-6" />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* {description && description.length > 0 ? (
        <div className="flex flex-col lg:flex-row gap-8 mt-8">
          <div className="w-full lg:w-2/3">
            <h2 className="mb-4 text-lg sm:text-xl md:text-2xl font-medium">
              Overall info
            </h2>
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
              {description}
            </p>
          </div>
          <div className="w-full lg:w-1/3">
            <iframe
              src={mapUrl}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      ) : (
        <div className="flex flex-col lg:flex-row gap-8 mt-8">
          <div className="w-full max-w-8xl">
            <iframe
              src={mapUrl}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default OverviewTitle;